<template>
  <div :class="[renderType,selectType]" class="calendar-container">
    <!-- Header Slot -->
    <slot name="header"></slot>

    <!-- 年份和月份选择 -->
    <div class="calendar-header">
      <div class="month-navigation">
        <span class="nav-btn prev-year" @click="changeYear(-1)">‹‹</span>
        <span class="nav-btn prev-month" @click="changeMonth(-1)">‹</span>
        <slot :headerInfo="{
          num:{
            year:currentYear,
            month:currentMonth,
          },
          ganZhi: {
            year:getGanZhiYearMonth(currentYear,currentMonth,currentDate.date(),'year'),
            month:getGanZhiYearMonth(currentYear,currentMonth,currentDate.date(),'month')
          }
        }"
              name="yearMonth">
          <span v-if="showYearMonth" class="current-date">
          <div class="current-date__year" @click="showFastSelect('showYearPicker')">{{
              ganZhi ? getGanZhiYearMonth(currentYear, currentMonth, currentDate.date(), 'year') : currentYear
            }}</div>年
          <div class="current-date__month" @click="showFastSelect('showMonthPicker')">{{
              ganZhi ? getGanZhiYearMonth(currentYear, currentMonth, currentDate.date(), 'month') : currentMonth + 1
            }}</div>月
        </span>
        </slot>
        <span class="nav-btn next-month" @click="changeMonth(1)">›</span>
        <span class="nav-btn next-year" @click="changeYear(1)">››</span>
      </div>
    </div>

    <div :class="`type__${renderType}`" style="position: relative;width: 100%;transition: height .3s">

      <transition name="van-fade">
        <div v-show="showYearPicker" class="fast-select-panel">
          <div class="year-panel">
            <div class="panel-header">
              <van-tag @click="changeYearRange(-10)">‹‹</van-tag>
              <div style="text-align: center">
                <div>{{yearRangeStart }} - {{yearRangeEnd }}</div>
                <div v-if="ganZhi" class="gan-zhi-text">
                  {{getGanZhiYearMonth(yearRangeStart, currentMonth, currentDate.date(), 'year')+'年'}}
                  -
                  {{getGanZhiYearMonth(yearRangeEnd, currentMonth, currentDate.date(), 'year')+'年'}}
                </div>
              </div>
              <van-tag @click="changeYearRange(10)">››</van-tag>
            </div>
            <div class="year-grid">
                <div
                    v-for="(year,index) in yearRange"
                    :key="year"
                    :class="{ active: year === currentYear }"
                    :style="{borderRight:(index+1)%4===0?'none':'1px solid var(--border-color)',borderBottom:index>=8?'none':'1px solid var(--border-color)'}"
                    @click="selectYear(year)"
                >
                  <div>{{year}}年</div>
                  <div v-if="ganZhi" class="gan-zhi-color">{{ getGanZhiYearMonth(year, currentMonth, currentDate.date(), 'year') }}</div>
                </div>
            </div>
          </div>
        </div>
      </transition>
      <transition name="van-fade">
        <div v-show="showMonthPicker" class="fast-select-panel">
          <div class="month-panel">
            <div class="panel-header">
              <van-tag @click="changeYear(-1)">‹‹</van-tag>
              <span>{{
                  ganZhi ? getGanZhiYearMonth(currentYear, currentMonth, currentDate.date(), 'year') : currentYear
                }}年</span>
              <van-tag @click="changeYear(1)">››</van-tag>
            </div>
            <div class="month-grid">
                <div
                    v-for="(month,index) in 12"
                    :key="month"
                    :class="{ active: month - 1 === currentMonth }"
                    :style="{borderRight:(index+1)%4===0?'none':'1px solid var(--border-color)',borderBottom:index>=8?'none':'1px solid var(--border-color)'}"
                    @click="selectMonth(month - 1)"
                >
                  <div>{{ month }}月</div>
                  <div v-if="ganZhi" class="gan-zhi-color">{{ getGanZhiYearMonth(currentYear, month - 1, currentDate.date(), 'month') }}</div></div>
            </div>
          </div>
        </div>
      </transition>

      <!-- 星期标题 -->
      <div class="week-header">
      <span v-for="day in weekDays" :key="day" :class="['六','日'].includes(day)?'weekend':''" class="week-day">{{
          day
        }}</span>
      </div>
      <transition-group
          class="date-grid"
          name="calendar"
          tag="div"
      >
        <!-- 日期网格 -->
        <div :key="`${currentYear}_${currentMonth}`"
             class="calendar-grid"
             style="width: 100%"
             @mousedown="onMouseDown"
             @mousemove="onMouseMove"
             @mouseup="onMouseEnd"
             @touchend="onTouchEnd"
             @touchmove="onTouchMove"
             @touchstart="onTouchStart"
        >
          <div
              v-for="(day, index) in calendarDays"
              :key="index"
              :class="getDayClasses(day)"
              @click="selectDate(day)"
          >
            <div class="day-content-block">
              <slot :day="day" name="day">
                <!-- 日期数字 -->
                <div :class="day.holiday===null?'':`day-is-${day.holiday.isWork?'work':'rest'}`" class="day-number">
                  {{ day.date.date() }}
                </div>
                <!-- 节日和节气显示 -->
                <!-- 默认节日显示 -->
                <van-tag v-for="festival in getDisplayFestivals(day.festivals)" v-if="day.festivals.length > 0&&showLunar" :key="festival.name" :class="festival.name.length>2?'overflow-tag':''"
                         :color="`rgb(from ${getFestivalColor(festival.type==='solar-term'?festival.subType:festival.type)} r g b / .5)`"
                         :text-color="getFestivalColor(festival.type==='solar-term'?festival.subType:festival.type)"
                         custom
                         not-border
                         plain
                         size="mini"
                         class="festival-item"

                >{{ festival.name }}
                </van-tag>
                <!-- 农历显示 -->
                <span v-if="showLunar&&!ganZhi&&day.festivals.length<=0" :class="day.lunar.day==='初一'?'lunar-date--start':''" class="lunar-date"
                      style="font-size: .6em">{{day.lunar.day === '初一' ? day.lunar.month + '月' : day.lunar.day }}</span>
                <span v-if="ganZhi&&(day.festivals.length<=0||!showLunar)" :class="day.lunar.day==='初一'?'lunar-date--start':''" class="lunar-date"
                      style="font-size: .6em">{{getGanZhiYearMonth(currentYear, currentMonth, day.date.date(), 'day') }}</span>
              </slot>

            </div>
            <van-tag v-if="day.isRangeEnd||day.isRangeStart"
                     not-border plain class="range-mark"
            >{{day.isRangeStart?'开始':''}}{{day.isRangeStart&&day.isRangeEnd?'/':''}}{{ day.isRangeEnd?'结束':''}}
            </van-tag>
          </div>
        </div>
      </transition-group>
    </div>

    <!-- Footer Slot -->
    <slot name="footer"></slot>

    <!-- 选择按钮 -->
    <div v-if="showSelectButton" class="selection-buttons">
      <van-button not-border square style="width: 50%" type="danger" @click="cancelSelection">{{
          cancelButtonText
        }}
      </van-button>
      <van-button not-border square style="width: 50%" type="primary" @click="confirmSelection">{{
          confirmButtonText
        }}
      </van-button>
    </div>

    <!-- 黄历区域 -->
    <div v-if="renderType === 'calendar'" class="almanac-section">
      <!-- 黄历内容，可以由父组件通过网络请求填充 -->
      <slot name="almanac"></slot>
    </div>

    <!-- 自定义内容区域 -->
    <div v-if="renderType === 'card'" class="custom-content">
      <slot></slot>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import {LunarMonth} from "lunar-javascript";
import {Dialog, Toast} from "vant";

const {Solar, Lunar, HolidayUtil} = require('lunar-javascript')
const errorType = {
  noSelectedError: {//
    name: 'NoSelectedError',
    message: '未选择日期'
  },
  exceedMaxLimit: {
    name: 'ExceedMaxLimitError',
    message: '超出最大范围',
  },
  dateNotSelectable: {
    name: 'DateNotSelectableError',
    message: '该日期不可选择',
  },
  sameDayNotAllowed: {
    name: 'SameDayNotAllowedError',
    message: '不允许选择同一天作为开始和结束日期',
  },
  invalidParameter: {
    name: 'InvalidParameter',
    message: '参数无效',
  },
  maxSelectionLimit: {
    name: 'MaxSelectionLimitError',
    message: '超过最大选择数量限制',
  },
  exceedMaxRange: {
    name: 'ExceedMaxRange',
    message: '超出最大范围'
  },
  invalidEndDate:{
    name: 'InvalidEndDate',
    message: '结束日期不在可选择的范围内',
  }
}
export default {
  name: 'EvanCalendar',
  props: {
    /**
     * 绑定的值
     */
    value: [Date, String, Array],
    /**
     * 是否显示快速选择
     */
    fastSelect: {
      type: Boolean,
      default: true
    },
    /**
     * 确认按钮文字
     */
    confirmButtonText: {
      type: String,
      default: '确 认'
    },
    /**
     * 取消按钮文字
     */
    cancelButtonText: {
      type: String,
      default: '取 消'
    },
    /**
     * 是否显示年月，当使用slot.yearMonth时此项失效
     */
    showYearMonth: {
      type: Boolean,
      default: true
    },
    /**
     * 显示确认按钮
     */
    showSelectButton: {
      type: Boolean,
      default: false
    },
    /**
     * 是否自动更新值，只有在showSelectButton为false时此项有效
     */
    autoBinding: {
      type: Boolean,
      default: true
    },
    /**
     * 最小选择范围，在此之前的日期不可选择
     */
    minDate: [Date, String],
    /**
     * 最大选择范围，在此之后的日期不可选择
     */
    maxDate: [Date, String],
    /**
     * 渲染类型，可选值为 'select','calendar','card',默认值为 'select'
     */
    renderType: {
      type: String,
      default: 'select',
      validator: (value) => ['select', 'calendar', 'card'].includes(value)
    },
    /**
     * 择日期的类型，默认值为 'date'<br/>
     * 当渲染类型为select时此项有效选，可选值为:<br/>
     * - date 选择单个日期<br/>
     * - multiple-date 日期多选<br/>
     * - range 选择日期范围
     */
    selectType: {
      type: String,
      default: 'date',
      validator: (value) => ['date', 'multiple-date', 'range'].includes(value)
    },
    /**
     * 最大选择范围/数量<br/>
     * 当 renderType 为 'select' 且 selectType 为 'multiple-date' 或 'range' 时有效<br/>
     * - 默认值为0，无限制
     * - 当 selectType 为 'multiple-date' 时，表示最大选择的日期范围<br/>
     * - 当 selectType 为 'range' 时，表示最大选择的数量<br/>
     */
    maxRange: {
      type: Number,
      default: 0
    },
    /**
     * 是否自动进行范围选择，默认为false<br/>
     * 当 maxRange>0 且 selectType 为 'range' 时有效<br/>
     * 当 maxRange>0 时，根据 rangeIncludeEnd 来设置结束日期
     * @example 参数设定：maxRange=3
     * rangeIncludeEnd = true , 选择的范围为： start,range,end
     * rangeIncludeEnd = false , 选择的范围为： start,range,range,end
     */
    autoRange: {
      type: Boolean,
      default: false,
    },
    /**
     * 是否包含结束日期<br/>
     * 当 renderType 为 'select' 且 selectType 为 'range' 、 maxRange 大于0时有效<br/>
     * - 默认 false<br/>
     * - 取值为 true 时，表示开始日期（包含）-结束日期（包含），即可选日期范围为 maxRange<br/>
     * - 取值为 false 时，表示开始日期（包含）-结束日期（不包含），即可选日期范围为 maxRange + 1<br/>
     */
    rangeIncludeEnd: {
      type: Boolean,
      default: false,
    },
    /**
     * 错误消息返回类型，默认为 toast<br/>
     * - 取值范围 ['toast', 'dialog', 'error']<br/>
     * - 取值为 'error' 时，表示以事件形式返回，可通过 @error 监听，返回的数据格式为对象格式<br/>
     * @example error:{name:'',message:''}<br/>
     */
    errorNotificationType: {
      type: String,
      default: 'toast',
      validator: (value) => ['toast', 'dialog', 'error'].includes(value)
    },
    /**
     * 是否允许起始日期为同一天，默认允许<br/>
     * 当 renderType 为 'select' 且 selectType 为 'range' 时有效<br/>
     */
    allowSameDay: {
      type: Boolean,
      default: true
    },
    /**
     * 格式化，输出的格式化的日期值，在 slot#day 中可以通过 day.formatter 属性获取
     */
    formatter: {
      type: Function,
      default: (date) => date.format('YYYY-MM-DD')
    },
    /**
     * 是否显示农历日期或节气，默认显示，当值为 true 且日期没有其他节日时才会显示，若开启了天干地支，则默认显示天干地支，若有节气或者节日，则优先显示节日或者节气<br/>
     * 其优先级为：节日节气＞天干地支＞农历日期
     */
    showLunar: {
      type: Boolean,
      default: true
    },
    /**
     * 节日显示优先级，由于单元格大小显示，因此日期网格内只能展示一个节日，可以通过此项进行配置，建议使用默认配置<br/>
     * - 默认值为 ['holiday', 'solar-term', 'lunar', 'solar', 'custom']<br/>
     * - 分别代表传统节日、农历节日、阳历节日、国际节日、自定义纪念日
     */
    festivalPriority: {
      type: Array,
      default: () => ['holiday', 'solar-term', 'lunar', 'solar', 'custom']
      // 法定节假日，   节气，   传统节日， 公历节日， 自定义纪念日
      //'commemoration' 纪念日
      //'other-lunar' 其他传统节日
    },
    /**
     * 自定义纪念日，会覆盖内置的custom。<br/>
     * 要求提供的格式为：<br/>
     * customFestivals:[{date:String,festivals:String}]<br/>
     * 其中：date属性的格式为：MMDD
     */
    customFestivals: {
      type: Array,
      default: () => []
    },
    ganZhi: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    const now = moment();
    return {
      currentYear: now.year(),
      currentMonth: now.month(),
      currentDate: now,
      selectedDates: [],
      rangeStart: null,
      rangeEnd: null,
      showYearPicker: false,
      showMonthPicker: false,
      yearRangeStart: Math.floor(now.year() / 10) * 10,
      yearRangeEnd: Math.floor(now.year() / 10) * 10 + 9,
      touchStartX: 0,
      touchStartY: 0,
      isDragging: false,
      touchStartTime: 0,
      hasSwiped: false,
      weekDays: ['日', '一', '二', '三', '四', '五', '六']
    };
  },
  computed: {
    calendarDays() {
      const days = [];
      const firstDay = moment({year: this.currentYear, month: this.currentMonth, day: 1});
      const lastDay = moment(firstDay).endOf('month');

      // 获取当前月份第一天是星期几（0-6，0代表星期日）
      const startDayOfWeek = firstDay.day();
      // 获取当前月份最后一天是星期几
      const endDayOfWeek = lastDay.day();
      // 当前月份的天数
      const daysInMonth = firstDay.daysInMonth();

      // 计算需要显示的上个月的天数
      // 如果当前月份第一天是星期日(0)，则不需要显示上个月的日子
      // 否则显示从星期日到当前月份第一天前一天的天数
      const prevMonthDays = startDayOfWeek === 0 ? 0 : startDayOfWeek;

      // 计算需要显示的下个月的天数
      // 确保整个日历显示完整的周（行），通常是5行或6行
      const totalCells = Math.ceil((prevMonthDays + daysInMonth) / 7) * 7;
      const nextMonthDays = totalCells - (prevMonthDays + daysInMonth);

      // 添加上个月末尾的几天
      if (prevMonthDays > 0) {
        const prevMonth = moment(firstDay).subtract(1, 'month');
        const daysInPrevMonth = prevMonth.daysInMonth();

        for (let i = prevMonthDays; i > 0; i--) {
          const date = moment(prevMonth).date(daysInPrevMonth - i + 1);
          days.push(this.createDayObject(date, 'prev'));
        }
      }

      // 添加当前月的所有日期
      for (let i = 1; i <= daysInMonth; i++) {
        const date = moment(firstDay).date(i);
        days.push(this.createDayObject(date, 'current'));
      }

      // 添加下个月开始的几天
      if (nextMonthDays > 0) {
        for (let i = 1; i <= nextMonthDays; i++) {
          const date = moment(firstDay).add(1, 'month').date(i);
          days.push(this.createDayObject(date, 'next'));
        }
      }

      return days;
    },
    yearRange() {
      const range = [];
      for (let i = this.yearRangeStart; i <= this.yearRangeEnd; i++) {
        range.push(i);
      }
      return range;
    },
    minDateMoment() {
      if (!this.minDate) return null;
      const date = moment(this.minDate);
      return date.isValid() ? date : null;
    },
    maxDateMoment() {
      if (!this.maxDate) return null;
      const date = moment(this.maxDate);
      return date.isValid() ? date : null;
    }
  },
  watch: {
    showMonthPicker: {
      handler(newVal) {
        if (newVal && this.showYearPicker) {
          this.showYearPicker = false;
        }
      },
    },
    showYearPicker: {
      handler(newVal) {
        if (newVal && this.showMonthPicker) {
          this.showMonthPicker = false;
        }
      },
    },
    value: {
      handler(newVal) {
        this.parseValue(newVal);
      },
      immediate: true
    }
  },
  methods: {
    resetSelected() {
      let output = undefined;
      switch (this.selectType) {
        case 'range':
        case 'multiple-date':
          output = [];
          break;
        case 'date':
          output = new Date();
          break;
      }
      if (output === undefined) {
        this.handleCalendarError(errorType.invalidParameter);
        return;
      }

      this.$emit('input', output);
      this.$emit('update', output);
    },
    showFastSelect(target) {
      if (this.fastSelect) {
        this[target] = !this[target];
      }
    },
    getGanZhiYearMonth(year, month, day, getType) {
      const lunarDate = Lunar.fromDate(new Date(year, month, day));

      switch (getType) {
        case 'year':
          return lunarDate.getYearInGanZhi()
        case 'month':
          return lunarDate.getMonthInGanZhi();
        case 'day':
          return lunarDate.getDayInGanZhi();

      }
    },
    createDayObject(date, type) {
      const l = Lunar.fromDate(date.toDate());
      return {
        date,
        type,
        lunar: {
          year: l.getYearInGanZhi(),
          month: l.getMonthInChinese(),
          day: l.getDayInChinese(),
          yearNum: l.getYear(),
          monthNum: l.getMonth(),
          dayNum: l.getDay(),
          isLeap: l.getMonth() < 0
        },
        festivals: this.getFestivals(date, l),
        isToday: date.isSame(moment(), 'day'),
        isSelected: this.isDateSelected(date),
        isDisabled: this.isDateDisabled(date),
        isRangeStart: this.isRangeStart(date),
        isRangeEnd: this.isRangeEnd(date),
        isInRange: this.isInRange(date),
        holiday: this.getHolidayByDate(date)
      };
    },

    getFestivals(date, lunar) {
      const festivals = [];
      const solar = Solar.fromDate(date.toDate());
      // 这里添加节日检测逻辑
      // 示例实现，实际需要更完整的节日数据库
      if (this.festivalPriority.includes('solar-term')) {
        if (lunar.getJieQi()) {
          festivals.push({
            name: lunar.getJieQi(),
            type: 'solar-term',
            subType: this.getSolarTermType(lunar.getJieQi())
          });
        }
      }
      // 传统节日检测
      if (this.festivalPriority.includes('lunar')) {
        const lunarFestivals = lunar.getFestivals().map(item => {
          return {
            name: item,
            type: 'lunar',
          }
        });
        festivals.push(...lunarFestivals);
      }
      //其他传统节日
      if (this.festivalPriority.includes('other-lunar')) {
        const otherLunarFestivals = lunar.getOtherFestivals().map(item => {
          return {
            name: item,
            type: 'other-lunar',
          }
        });
        festivals.push(...otherLunarFestivals);
      }
      //公历节日
      if (this.festivalPriority.includes('solar')) {
        const solarFestivals = solar.getFestivals().map(item => {
          return {
            name: item,
            type: 'solar',
          }
        });
        festivals.push(...solarFestivals);
      }
      //纪念日
      if (this.festivalPriority.includes('commemoration')) {
        const commemorationFestivals = solar.getOtherFestivals().map(item => {
          return {
            name: item,
            type: 'commemoration',
          }
        });
        festivals.push(...commemorationFestivals);
      }
      //自定义纪念日
      if (this.festivalPriority.includes('custom')) {
        let format = date.format('MMDD');
        const custom = this.customFestivals||[
          {date: '0207', festival: '二七纪念日'},
          {date: '0415', festival: '全民国家安全教育日'},
          {date: '0424', festival: '中国航天日'},
          {date: '0510', festival: '中国品牌日'},
          {date: '0512', festival: '全国防灾减灾日'},
          {date: '0519', festival: '中国旅游日'},
          {date: '0530', festival: '五卅纪念日'},
          {date: '0711', festival: '中国航海日'},
          {date: '0815', festival: '日本投降日'},
          {date: '0903', festival: '中国人民抗战胜利纪念日'},
          {date: '0903', festival: '世界反法西斯战争胜利纪念日'},
          {date: '0918', festival: '九一八纪念日'},
          {date: '0930', festival: '烈士纪念日'},
          {date: '1202', festival: '全国交通安全日'},
          {date: '1204', festival: '国家宪法日暨全国法制宣传日'},
          {date: '1213', festival: '南京大屠杀死难者国家公祭日'},
        ];
        for (let i = 0; i < custom.length; i++) {
          if (custom[i].date === format) {
            festivals.push({
              name: custom[i].festival,
              type: 'custom'
            })
          }
        }
      }
      return festivals;
    },

    getDisplayFestivals(festivals) {
      // 根据优先级返回要显示的节日
      for (const priority of this.festivalPriority) {
        const festival = festivals.find(f => f.type === priority);
        if (festival) return [festival];
      }
      return festivals.slice(0, 1); // 默认显示第一个
    },

    getFestivalColor(type) {
      const colorMap = {
        'solar': 'var(--solar-festival, #58a6ff)',//公历节日
        'lunar': 'var(--lunar-festival, #ff7b72)',//农历节日
        'international': 'var(--international-festival, #d2a8ff)',//国际节日
        'custom': 'var(--day-of-commemoration, #ffa657)',//纪念日
        'season': 'var(--solar-term, #e3b341)',
        'temperature': 'var(--solar-terms__temperature, #79c0ff)',
        'rain': 'var(--solar-terms__rain:, #a5d6ff)',
        'farming': 'var(--solar-terms__farming, #7ee787)',
        'solar-term': 'var(--solar-term, #e3b341)',
      };

      return colorMap[type] || 'var(--text-color, #c9d1d9)';
    },

    getDayClasses(day) {
      return [
        'calendar-day',
        day.type,
        {
          'today': day.isToday,
          'selected': day.isSelected,
          'disabled': day.isDisabled,
          'range-start': day.isRangeStart,
          'range-start-and-end': day.isRangeStart && day.isRangeEnd,
          'range-end': day.isRangeEnd,
          'in-range': day.isInRange,
          'weekend': day.date.day() === 0 || day.date.day() === 6
        }
      ];
    },


    selectDate(day) {
      if (this.renderType === 'calendar') {
        this.selectedDates = [day.date];
        return;
      }
      if (day.isDisabled) {
        this.handleCalendarError(errorType.dateNotSelectable);
        return;
      }
      if (day.type === 'prev') {
        this.changeMonth(-1)
      } else if (day.type === 'next') {
        this.changeMonth(1)
      }
      if (this.renderType === 'select') {
        this.handleSelectMode(day);
      } else if (this.renderType === 'card') {
        this.$emit('date-select', {
          date: day.date,
          index: this.selectedDates.findIndex(d => d.isSame(day.date, 'day'))
        });
      }
      if (this.autoBinding && !this.showSelectButton && this.selectType==='range'?this.rangeEnd!==null:true) {
        this.updateValue();
      }
    },

    handleSelectMode(day) {
      switch (this.selectType) {
        case 'date':
          this.selectedDates = [day.date];
          break;
        case 'multiple-date':
          this.handleMultipleDateSelection(day);
          break;
        case 'range':
          this.handleRangeSelection(day);
          break;
      }
    },
    handleMultipleDateSelection(day) {
      const index = this.selectedDates.findIndex(d => d.isSame(day.date, 'day'));
      if (index > -1) {
        this.selectedDates.splice(index, 1);
      } else {
        if ((this.maxRange > 0 && this.selectedDates.length < this.maxRange) || this.maxRange <= 0) {
          this.selectedDates.push(day.date);
        } else {
          this.handleCalendarError(errorType.maxSelectionLimit);
        }
      }
    },
    handleRangeSelection(day) {
      if (!this.rangeStart || (this.rangeStart && this.rangeEnd) || (this.rangeStart && day.date.isBefore(this.rangeStart))) {
        this.rangeStart = day.date;
        this.rangeEnd = null;
        // 新增：autoRange 功能
        if (this.autoRange && this.maxRange > 0) {
          // 计算结束日期
          const calculatedEndDate = moment(this.rangeStart).add(this.maxRange - (this.rangeIncludeEnd?1:0), 'days');

          // 检查结束日期是否在最大允许日期范围内
          if (this.maxDate) {
            const maxDateMoment = moment(this.maxDate);
            if (!this.allowSameDay && this.rangeStart.isSame(calculatedEndDate, 'day')) {
              this.handleCalendarError(errorType.sameDayNotAllowed);
              this.rangeEnd = null;

            }else if (calculatedEndDate.isAfter(maxDateMoment, 'day')) {
              // 结束日期超出最大允许日期
              this.handleCalendarError(errorType.invalidEndDate);
              this.rangeEnd = null;
            } else {
              // 结束日期在允许范围内
              this.rangeEnd = calculatedEndDate;
            }
          } else {
            // 没有配置 maxDate，直接设置结束日期
            this.rangeEnd = calculatedEndDate;
          }
        }
      } else {
        this.rangeEnd = day.date
        // 检查是否允许同一天
        if (!this.allowSameDay && this.rangeStart.isSame(this.rangeEnd, 'day')) {
          this.handleCalendarError(errorType.sameDayNotAllowed);
          this.rangeEnd = null;
        } else if (this.maxRange > 0) {
          // 计算实际选择的天数
          const diffDays = Math.abs(this.rangeStart.diff(this.rangeEnd, 'days'));

          // 根据 rangeIncludeEnd 计算总天数
          const totalDays = this.rangeIncludeEnd ? diffDays + 1 : diffDays;

          // 如果超出最大范围，调整结束日期
          if (totalDays > this.maxRange) {
            this.handleCalendarError(errorType.exceedMaxLimit);
            // 计算允许的最大天数差
            const allowedDiff = this.rangeIncludeEnd ? this.maxRange - 1 : this.maxRange;
            if (this.rangeEnd.isAfter(this.rangeStart)) {
              this.rangeEnd = moment(this.rangeStart).add(allowedDiff, 'days');
            } else {
              this.rangeStart = moment(this.rangeEnd).add(allowedDiff, 'days');
            }
          }
        }
      }

      this.selectedDates = this.rangeEnd ?
          [this.rangeStart, this.rangeEnd] :
          [this.rangeStart];
    },

    // 触摸事件处理
    onTouchStart(event) {
      this.touchStartX = event.touches[0].clientX;
      this.touchStartY = event.touches[0].clientY;
      this.touchStartTime = Date.now();
      this.isDragging = true;
      this.hasSwiped = false;
    },

    onTouchMove(event) {
      if (!this.isDragging || this.hasSwiped) return;

      const touchX = event.touches[0].clientX;
      const touchY = event.touches[0].clientY;
      const diffX = touchX - this.touchStartX;
      const diffY = touchY - this.touchStartY;
      const absDiffX = Math.abs(diffX);
      const absDiffY = Math.abs(diffY);

      // 滑动阈值检测
      if (absDiffX < 30 && absDiffY < 30) return;

      // 判断主要滑动方向
      let direction = null;
      if (absDiffX > absDiffY) {
        // 水平滑动
        direction = diffX > 0 ? 'right' : 'left';
      } else {
        // 垂直滑动
        direction = diffY > 0 ? 'down' : 'up';
      }

      // 统一处理滑动方向
      event.preventDefault();
      this.handleSwipe(direction);
      this.hasSwiped = true;
      this.isDragging = false;
    },
// 处理滑动操作
    handleSwipe(direction) {
      let monthChange = 0;

      switch (direction) {
        case 'left':
        case 'up':
          // 向左滑动或向上滑动 -> 切换到下个月
          monthChange = 1;
          break;
        case 'right':
        case 'down':
          // 向右滑动或向下滑动 -> 切换到上个月
          monthChange = -1;
          break;
      }

      if (monthChange !== 0) {
        this.changeMonth(monthChange);
      }
    },
    onTouchEnd() {
      this.isDragging = false;
      this.hasSwiped = false;
    },

    // 鼠标事件处理（PC端支持）
    onMouseDown(event) {
      this.touchStartX = event.clientX;
      this.touchStartY = event.clientY;
      this.isDragging = true;
    },

    onMouseMove(event) {
      if (!this.isDragging) return;

      const diffX = event.clientX - this.touchStartX;
      if (Math.abs(diffX) > 50) {
        if (diffX > 0) {
          this.changeMonth(-1);
        } else {
          this.changeMonth(1);
        }
        this.isDragging = false;
      }
    },

    onMouseEnd() {
      this.isDragging = false;
    },

    changeMonth(offset) {
      let newDate = moment({year: this.currentYear, month: this.currentMonth}).add(offset, 'months');
      this.currentYear = newDate.year();
      this.currentMonth = newDate.month();
    },

    changeYear(offset) {
      this.currentYear += offset;
    },

    changeYearRange(offset) {
      this.yearRangeStart += offset;
      this.yearRangeEnd += offset;
    },

    selectYear(year) {
      this.currentYear = year;

      this.showYearPicker = false;
      this.showMonthPicker = true;
    },

    selectMonth(month) {
      this.currentMonth = month;

      this.showMonthPicker = false;

    },

    confirmSelection() {
      this.updateValue();
      this.$emit('confirm', this.selectedDates);
    },

    cancelSelection() {
      this.parseValue(this.value);
      this.$emit('cancel');
    },

    updateValue() {
      let output;
      if (this.selectType === 'range' && this.selectedDates.length === 2) {
        output = [this.selectedDates[0].toDate(), this.selectedDates[1].toDate()];
      } else if (this.selectType === 'multiple-date') {
        output = this.selectedDates.map(d => d.toDate());
      } else {
        output = this.selectedDates[0] ? this.selectedDates[0].toDate() : null;
      }

      this.$emit('input', output);
      this.$emit('update', output);
    },

    parseValue(value) {
      if (!value) {
        this.selectedDates = [moment()];
        return;
      }

      if (Array.isArray(value)) {
        this.selectedDates = value.map(v => moment(v)).filter(m => m.isValid());
        if (this.selectType === 'range' && this.selectedDates.length >= 2) {
          this.rangeStart = this.selectedDates[0];
          this.rangeEnd = this.selectedDates[1];
        }
      } else {
        const date = moment(value);
        this.selectedDates = date.isValid() ? [date] : [moment()];
      }
    },

    isDateSelected(date) {
      return this.selectedDates.some(selected => selected.isSame(date, 'day'));
    },

    isDateDisabled(date) {
      if (this.minDateMoment && date.isBefore(this.minDateMoment, 'day')) return true;
      if (this.maxDateMoment && date.isAfter(this.maxDateMoment, 'day')) return true;
      return false;
    },

    isRangeStart(date) {
      return this.rangeStart && date.isSame(this.rangeStart, 'day');
    },

    isRangeEnd(date) {
      return this.rangeEnd && date.isSame(this.rangeEnd, 'day');
    },

    isInRange(date) {
      if (!this.rangeStart || !this.rangeEnd) return false;
      // 如果起止日期是同一天，不显示范围样式
      if (this.rangeStart.isSame(this.rangeEnd, 'day') || date.isSame(this.rangeStart, 'day') || date.isSame(this.rangeEnd, 'day')) return false;
      return date.isBetween(this.rangeStart, this.rangeEnd, 'day', '[]');
    },
    getHolidayByDate(date) {
      let d = HolidayUtil.getHoliday(date.format('YYYY-MM-DD'));
      if (!d) return null;
      return {
        isWork: d.isWork(),
        holiday: d.getName(),
        relevance: d.getTarget(),

      }
    },

    /**
     * 二十四节气划分依据是根据斗转星移， 圭表测影， 太阳黄经。二十四节气可分为四类<br/>
     * 表示寒来暑往变化的有：立春、春分；立夏、夏至；立秋、秋分；立冬、冬至。<br/>
     * 象征气温变化的有：小暑、大暑、处暑、小寒、大寒。<br/>
     * 反映降水量的有：雨水、谷雨、白露、寒露、霜降、小雪、大雪。<br/>
     * 反映物候现象或农事活动的有：惊蛰、清明、小满、芒种。
     * @param term
     * @returns {*|string}
     */
    getSolarTermType(term) {
      const season = ['立春', '春分', '立夏', '夏至', '立秋', '秋分', '立冬', '冬至'];
      const temperature = ['小暑', '大暑', '处暑', '小寒', '大寒'];
      const rain = ['雨水', '谷雨', '白露', '寒露', '霜降', '小雪', '大雪'];
      const farming = ['惊蛰', '清明', '小满', '芒种'];
      if (season.includes(term)) {
        return 'season';
      }
      if (temperature.includes(term)) {
        return 'temperature';
      }
      if (rain.includes(term)) {
        return 'rain';
      }
      if (farming.includes(term)) {
        return 'farming';
      }
    },
    handleCalendarError(error) {
      switch (this.errorNotificationType) {
        case 'dialog':
          Dialog.alert({message: error.message, showConfirmButton: true})
          break;
        case 'toast':
          Toast.fail({message: error.message, duration: 3000})
          break;
        default:
          this.$emit('error', error);
      }
    },
  },

};
</script>

<style scoped>
.calendar-container {
  width: 100%;
  background: var(--bg-color);
  overflow: hidden;
}

.calendar-container:not(.range) {
  .calendar-day {
    border-radius: 50%;
  }

  .calendar-grid {
    gap: .5em;
  }
}

.calendar-container.select.range {
  .calendar-grid {
    row-gap: 1em;

  }

  .calendar-day {
    //aspect-ratio: 1/1.5;
    border: none;
  }

  .calendar-day.range-start-and-end {
    border-radius: .5em !important;
    border: 1px solid var(--positive-color);
  }

  .calendar-grid:not(:has(.in-range,.range-end)) {
    .calendar-day.range-start {
      border: 1px solid var(--active-color) !important;
      border-radius: .5em !important;
    }
  }

  .calendar-day.range-start-and-end,
  .calendar-day.range-start,
  .calendar-day.in-range,
  .calendar-day.range-end {
    background: rgb(from var(--active-color) r g b / .3) !important;
    filter: none !important;
    transition: all .3s;
  }

  .calendar-grid:not(:has(.range-start-and-end)) {
    .calendar-day.range-start,
    .calendar-day.in-range,
    .calendar-day.range-end {
      border-top: 1px solid var(--positive-color);
      border-bottom: 1px solid var(--positive-color);
    }
    .calendar-day.range-start {
      border-radius: .5em 0 0 .5em;
      border-left: 1px solid var(--positive-color);
    }

    .calendar-day.range-end {
      border-radius: 0 .5em .5em 0;
      border-right: 1px solid var(--positive-color);

    }
    .calendar-day.in-range {
      background-color: rgb(from var(--active-color) r g b / .2);
    }
  }
.range-mark {
  font-size: .6em;
  position: absolute;
  top: calc(100% + .2em);
  padding: 0 2px;
  white-space: nowrap;
  isolation: isolate;
}

}

.calendar-container.select.date, .calendar-container.select.multiple-date {
  .calendar-day.selected {
    filter: none !important;
    background-color: rgb(from var(--active-color) r g b / .3);
    color: var(--text-color) !important;
  }
}

.calendar-container.calendar {

  .calendar-day.selected {
    border-color: var(--active-color);
  //color: white;
  }

  .calendar-day.selected.today {
    border-color: var(--active-color);
    background: rgb(from var(--active-color) r g b / .3);

    & * {
      color: var(--text-color) !important;
    }

  //color: white;
  }

}

.calendar-header {
  width: 100%;
  text-align: center;
  border-bottom: 1px solid var(--border-color, #30363d);
}

.current-date {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}

.current-date__year {
  padding: .5em;
  color: var(--active-color);
}

.current-date__month {
  padding: .5em;
  color: var(--active-color);
}


.month-navigation {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.nav-btn {
  cursor: pointer;
  padding: 5px 10px;
  user-select: none;
}

.year-select,
.month-select {
  cursor: pointer;
  padding: 5px 10px;
  margin: 0 5px;
}

.week-header {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  text-align: center;
  padding: .5em 1em;
  border-bottom: 1px solid var(--border-color, #30363d);
}

.week-day {
  font-weight: bold;
  color: var(--text-color, #c9d1d9);
}

.week-day.weekend {
  color: var(--footer-color);

}

.calendar-move {
  transition: transform 0.3s ease;
}

.calendar-enter-active, .calendar-leave-active {
  transition: all 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94);
}

.calendar-enter, .calendar-leave-to {
  opacity: 0;
//transform: scale(0.8);
}

.calendar-leave-active {
  position: absolute;
}

.calendar-grid {
  width: 100%;
  padding: 1em;
  transition: all .3s;
  grid-template-rows:repeat(6,1fr);
  display: grid;
  grid-template-columns: repeat(7, 1fr);
}

.calendar-day {
  aspect-ratio: 1/1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border: 1px solid transparent;
  position: relative;
  width: 100%;

  cursor: pointer;
  position: relative;
  transition: all .3s;
}


.calendar-day.prev,
.calendar-day.next {
  font-weight: 100 !important;

  /*color: var(--footer-color) !important*/;
  filter: opacity(.3) !important;


}

.calendar-day.today {
  color: var(--active-color) !important;
  font-weight: bold;
}


.calendar-day.disabled {
  & * {
    text-decoration: line-through
  }

  color: var(--negative-color) !important;
  cursor: not-allowed;
}

.calendar-day.weekend {
//color: var(--footer-color); color: var(--footer-color);

  .day-number {
  //color: rgb(from var(--footer-color) r g b / .8);
  }
}

.day-content-block {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;

}

.day-number {
  position: relative;
  font-size: 1.5em;
  line-height: 1em;
  font-weight: bolder;
  text-align: center;
}

.day-number.day-is-rest::before {
  content: '休';
  color: var(--active-color);
}

.day-number.day-is-work::before {
  content: '班';
  color: var(--negative-color);
}

.day-number.day-is-rest::before,
.day-number.day-is-work::before {
  font-size: .3em !important;
  position: absolute;
  left: 100%;
  top: -50%;
}

.day-content {
  font-size: .6em;
  text-align: center;
  width: 100%;
}


.overflow-tag {
  display: inline-block;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  text-align: center;
}

.lunar-date {
  font-size: .9em;
  line-height: 1;
  color: var(--desc-color);
  font-weight: bolder;
  position: relative;
}

.lunar-date.lunar-date--start::after {
  position: absolute;
  content: ' ';
  bottom: -2px;
  left: 0;
  right: 0;
  border-bottom: 1px solid var(--active-color);

}

.fast-select-panel {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  z-index: 2;
}

.year-panel,
.month-panel {
//padding: 1em; width: 100%;
  height: 100%;
  background: var(--bg-color);
}

.panel-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 3em;
  padding: 0 2em;
  border-bottom: 1px dashed var(--border-color);
}


.year-grid,
.month-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  height: calc(100% - 3em);
  border-bottom: 1px solid var(--border-color);

}


.year-grid>div,
.month-grid>div {
  transition: all .3s;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  cursor: pointer;

}

.year-grid span.active,
.month-grid span.active {
  background-color: #007bff;
  color: white;
}

.selection-buttons {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;

}

.almanac-section,
.custom-content {
  padding: 20px;
  border-top: 1px solid var(--border-color, #30363d);
}
.festival-item {
  font-size: .6em;
  max-width: 6ch;
  padding: 0;

  white-space: nowrap;
  line-height: 1;
}
.gan-zhi-text {
  font-size: .6em;
}
.gan-zhi-color{
  color: var(--footer-color);
}
</style>
